export const ROUTE_NAME = {
  HOME: {
    MAIN: "HomeMain",
    COMPLETE: "Complete",
    B2B: {
      MAIN: "HomeB2BLayout",
      FACT_FIND: "B2BHomeFactFindPage",
      COVER_TYPE: "B2BHomeCoverTypePage",
      YOUR_DETAILS: "B2BHomeYourDetailsPage",
      PROPERTY_DETAILS: "B2BHomePropertyDetailsPage",
      QUOTATION_RESULT: "B2BHomeYourQuotesPage",
      APPLICATION: "B2BHomeYourApplicationPage",
      PAYMENT: "B2BHomePaymentPage",
      COMPLETE: "B2BHomeCompletePage",
    },
    D2C: {
      LANDING_PAGE: "LandingPage",
      COMPLETE: "Success",
    },
  },
  LANDLORDS: {
    B2B: {
      LANDING_PAGE: "",
      MAIN: "LandlordsB2BLayout",
      FACT_FIND: "FactFindPage",
      COVER_TYPE: "CoverTypePage",
      YOUR_DETAILS: "YourDetailsPage",
      PROPERTY_DETAILS: "PropertyDetailsPage",
      QUOTATION_RESULT: "YourQuotesPage",
      APPLICATION: "YourApplicationPage",
      PAYMENT: "PaymentPage",
      COMPLETE: "CompletePage",
    },
    D2C: {
      LANDING_PAGE: "WelcomePageD2CLandlords",
      MAIN: "D2CLandlordsLayout",
      COVER_TYPE: "D2CLandlordCoverTypePage",
      YOUR_DETAILS: "D2CLandlordYourDetailsPage",
      PROPERTY_DETAILS: "D2CLandlordPropertyDetailsPage",
      COVER_DETAILS: "D2CLandlordCoverDetailsPage",
      QUOTATION_RESULT: "D2CLandlordQuotationResultPage",
      APPLICATION: "D2CLandlordYourApplicationPage",
      PAYMENT: "D2CLandlordPaymentPage",
      COMPLETE: "D2CLandLordApplicationSuccessPage",
    },
  },
  TENANTS_CONTENTS: {
    B2B: {
      MAIN: "B2BTenantsMainLayout",
      YOUR_DETAILS: "B2BTenantsContentsYourDetailsPage",
      PROPERTY_DETAILS: "B2BTenantsContentsPropertyDetailsPage",
      QUOTATION_RESULT: "B2BTenantsContentsYourQuotesPage",
      APPLICATION: "B2BTenantsContentsYourApplicationPage",
      PAYMENT: "B2BTenantsContentsPaymentPage",
      COMPLETE: "B2BTenantsContentsCompletePage",
    },
  },
  TENANTS_LIABILITY: {
    B2B: {
      MAIN: "B2BTenantsLiabilityLayout",
      YOUR_DETAILS: "B2BTenantsLiabilityYourDetailsPage",
      PROPERTY_DETAILS: "B2BTenantsLiabilityPropertyDetailsPage",
      QUOTATION_RESULT: "B2BTenantsLiabilityYourQuotePage",
      APPLICATION: "B2BTenantsLiabilityYourApplicationPage",
      PAYMENT: "B2BTenantsLiabilityPaymentPage",
      COMPLETE: "B2BTenantsLiabilityCompletePage",
    },
  },
  MPPI: {
    B2B: {
      MAIN: "B2BMPPILayout",
      YOUR_DETAILS: "B2BMPPIYourDetailsPage",
      COVER_DETAILS: "B2BMPPICoverDetailsPage",
      QUOTATION_RESULT: "B2BMPPIYourQuotesPage",
      APPLICATION: "B2BMPPIYourApplicationPage",
      PAYMENT: "B2BMPPIPaymentPage",
      COMPLETE: "B2BMPPICompletePage",
    },
  },
  CONTACT_US: "ContactUs",
};

export const ROUTE_URL = {
  LANDLORD_D2C: "d2c/landlords",
  D2C: "d2c",
  LANDLORD_D2C_LANDINGPAGE: "/d2c/landlords/welcome",
  HOME_D2C_LANDINGPAGE: "/home",
  TENANTS_B2B: "b2b/tenants-contents",
  MPPI_B2B: "b2b/mppi",
};

export const PATHS_ARRAY_EXCLUDE_CHECK_UNSAVED_DATA = [
  "/complete",
  "/home",
  "/application-success",
  "/contact-us",
  "/d2c/landlords/welcome",
  "/d2c/landlords/complete",
  "/b2b/tenants-contents/complete",
  "/b2b/landlords/complete",
  "/b2b/tenants-liability/complete",
  "/b2b/home/complete",
  "/b2b/mppi/complete",
  "/d2c/home/complete",
];

export const LIST_PAGE_D2C_SHOW_FOOTER = [
  ROUTE_NAME.HOME.D2C.LANDING_PAGE,
  ROUTE_NAME.CONTACT_US,
  ROUTE_NAME.LANDLORDS.D2C.LANDING_PAGE,
];
